// routeUtils.js
export const getDefaultRouteForRole = (role) => {
    const routeMap = {
        business: '/vendor/dashboard',
        mall: '/vendor/dashboard',
        sub_business: '/shop/offers',
        marketer: '/marketer/dashboard',
    };
    return routeMap[role] || '/login';
};
